@if (service.showModal()) {
  <button
    type="button"
    class="animate-fade-in fixed inset-0 z-100 cursor-default bg-neutral-100/50"
    [attr.aria-label]="'modal.close' | transloco"
    (click)="onBackdropClick()"
  ></button>
  <div class="pointer-events-none fixed inset-0 z-101 flex items-center justify-center px-4">
    <div
      class="animate-modal-pop-in"
      [class]="wrapperClass()"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      role="dialog"
      aria-modal="true"
    >
      <ng-container
        [ngComponentOutlet]="modal()!.component"
        [ngComponentOutletInjector]="modal()!.injector"
      />
    </div>
  </div>
}
